const baseUrl = process.env.NODE_ENV === "production"
  ? "https://uyygv3wln6.execute-api.eu-west-1.amazonaws.com/default/"
  : "http://localhost:3001/";

async function getLessonRegister(id) {
  const response = await fetch(`${baseUrl}lessonregister/${id}`);
  if (response.ok) return response.json();
  throw response;
}

async function getLessonRegisters() {
  const response = await fetch(`${baseUrl}lessonregister/`);
  if (response.ok) return response.json();
  throw response;
}

async function saveLessonRegister(lessonRegister) {
  const lessonRegisterId = lessonRegister.id && lessonRegister.id !== lessonRegister.lessonId
    ? lessonRegister.id
    : (lessonRegister.lessonId || lessonRegister.id || "");
  const persistedRecordId = lessonRegister.id || lessonRegisterId;

  const response = await fetch(`${baseUrl}lessonregister/${lessonRegisterId}`, {
    method: "PUT",
    headers: { "content-type": "application/json" },
    body: JSON.stringify({
      ...lessonRegister,
      id: persistedRecordId,
    }),
  });
  if (response.ok) return response.json();
  throw response;
}

async function deleteLessonRegister(id) {
  const response = await fetch(`${baseUrl}lessonregister/${id}`, {
    method: 'DELETE',
    headers: { 'content-type': 'application/json' },
  });
  if (response.ok) return response.json();
  throw response;
}

export default {
  getLessonRegister,
  getLessonRegisters,
  saveLessonRegister,
  deleteLessonRegister,
};
